import { useState } from 'react';

function TextArea(props) {
  const {
    value, onChange, accept, placeholder, name, type, error, required, onBlur = () => {}, className, min, max, step,
  } = props;

  const [focus, setFocus] = useState(false);

  const v = value;

  return (
    <div className={`${className}`}>
      <div className={`relative bg-white block w-full border-0 rounded-md shadow-sm ${focus ? 'ring ring-sentric-dark-gray ring-opacity-50' : ''} ${required ? 'required-star' : ''}`}>
        <textarea
          className={[
            ' h-36 border-0 focus:outline-none focus:ring-0 w-full bg-transparent text-md p-2 pl-3 pr-3 text-sentric-dark-gray',
            (v || ['file', 'date'].includes(type)) ? 'pt-6' : '',
          ].join(' ')}
          id={name}
          name={name}
          value={v}
          onFocus={() => setFocus(true)}
          onBlur={() => { setFocus(false); onBlur(); }}
          onChange={onChange}
          min={min}
          max={max}
          step={step}
          accept={accept}
        />
        <label
          className={[
            'absolute pointer-events-none top-0 left-0 flex items-center text-gray-500 p-2 pl-3 pr-3',
            (v || ['file', 'date'].includes(type)) ? 'text-xs' : 'text-md',
          ].join(' ')}
          htmlFor={name}
        >
          {placeholder}
        </label>

      </div>
      {!!error
      && <p className="w-4/5 error-arrow-top text-sm inline-block p-1 pr-3 pl-3 bg-red-700 mt-2 text-white rounded-lg border-white border">{error}</p>}
    </div>

  );
}

export default TextArea;
